import { UUID_REGEX } from '@constants/routes';
import { generatePath } from '@helpers/route';

const path = '/settings/tax-codes';

const ENTITY_JURISDICTION_ID = `:entityJurisdictionId(${UUID_REGEX})`;

export const taxCodesRoutes = {
  ROOT: {
    get rule() {
      return path;
    },
    get make() {
      return () => this.rule;
    },
  },
  COPY_FROM: {
    get rule() {
      return `${path}/copy/from/${ENTITY_JURISDICTION_ID}`;
    },
    get make() {
      return entityJurisdictionId => generatePath(this.rule, { entityJurisdictionId });
    },
  },
  COPY_TO: {
    get rule() {
      return `${path}/copy/to/${ENTITY_JURISDICTION_ID}`;
    },
    get make() {
      return entityJurisdictionId => generatePath(this.rule, { entityJurisdictionId });
    },
  },
  CREDIT_NOTE: {
    get rule() {
      return `${path}/credit-note/${ENTITY_JURISDICTION_ID}?`;
    },
    get make() {
      return entityJurisdictionId => generatePath(this.rule, { entityJurisdictionId });
    },
  },
  DETAILS: {
    get rule() {
      return `${path}/details/${ENTITY_JURISDICTION_ID}`;
    },
    get make() {
      return entityJurisdictionId => generatePath(this.rule, { entityJurisdictionId });
    },
  },
  DETAILS_CREDIT: {
    get rule() {
      return `${path}/details/${ENTITY_JURISDICTION_ID}/:entityName?/credit/:credit/:view?`;
    },
    get make() {
      return (entityJurisdictionId, entityName, credit, view) =>
        generatePath(this.rule, { entityJurisdictionId, entityName, credit, view });
    },
  },
  MANUAL: {
    get rule() {
      return `${path}/manual/${ENTITY_JURISDICTION_ID}/:add?/:transactionType`;
    },
    get make() {
      return (entityJurisdictionId, add, transactionType) =>
        generatePath(this.rule, { entityJurisdictionId, add, transactionType });
    },
  },
  REDUCED_RATES: {
    get rule() {
      return `${path}/reduce-rates/${ENTITY_JURISDICTION_ID}`;
    },
    get make() {
      return entityJurisdictionId => generatePath(this.rule, { entityJurisdictionId });
    },
  },
  TAX_CODES: {
    get rule() {
      return `${path}/:entityName?`;
    },
    get make() {
      return entityName => generatePath(this.rule, { entityName });
    },
  },
  WIZARD: {
    get rule() {
      return `${path}/wizard/${ENTITY_JURISDICTION_ID}?`;
    },
    get make() {
      return entityJurisdictionId => generatePath(this.rule, { entityJurisdictionId });
    },
  },
};
